import { ApiReducer as api } from 'reactifi-local';
import { routerReducer } from 'react-router-redux';

export default {
  api,
  routing: routerReducer,
};
